import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addWhoAreWe as addWhoAreWeApi,
  updateWhoAreWe as updateWhoAreWeApi,
  getWhoAreWe as getWhoAreWeApi,
  deleteWhoAreWe as deleteWhoAreWeApi,
} from "../../helpers/";

// actions
import {
  whoAreWeDataApiResponseSuccess,
  whoAreWeDataApiResponseError,
  getWhoAreWeData,
} from "./actions";

// constants
import { WhoAreWeActionTypes } from "./constants";

interface whoAreWeData {
  payload: {
    id: number;
    experience: string;
    users: string;
    courses: string;
    file: any;
    head: string;
    subhead: string;
    head_ar: string;
    subhead_ar: string;
  };
  type: string;
}

function* createWhoAreWeData({
  payload: {
    experience,
    users,
    courses,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
  },
  type,
}: whoAreWeData): SagaIterator {
  try {
    const response = yield call(addWhoAreWeApi, {
      experience,
      users,
      courses,
      file,
      head,
      subhead,
      head_ar,
      subhead_ar,
    });

    const whoAreWeData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      whoAreWeDataApiResponseSuccess(
        WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA,
        whoAreWeData
      )
    );
    yield put(getWhoAreWeData());
  } catch (error: any) {
    yield put(
      whoAreWeDataApiResponseError(
        WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA,
        error
      )
    );
  }
}

function* updateWhoAreWeData({
  payload: {
    id,
    experience,
    users,
    courses,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
  },
}: whoAreWeData): SagaIterator {
  try {
    const response = yield call(updateWhoAreWeApi, id, {
      experience,
      users,
      courses,
      file,
      head,
      subhead,
      head_ar,
      subhead_ar,
    });
    const whoAreWeData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      whoAreWeDataApiResponseSuccess(
        WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA,
        whoAreWeData
      )
    );
    yield put(getWhoAreWeData());
  } catch (error: any) {
    yield put(
      whoAreWeDataApiResponseError(
        WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA,
        error
      )
    );
  }
}

function* getWhoAreWeDatas(): SagaIterator {
  try {
    const response = yield call(getWhoAreWeApi);

    const whoAreWeData = response?.data?.data;

    yield put(
      whoAreWeDataApiResponseSuccess(
        WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA,
        whoAreWeData
      )
    );
  } catch (error: any) {
    yield put(
      whoAreWeDataApiResponseError(
        WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA,
        error
      )
    );
  }
}

function* deleteWhoAreWeData({ payload: { id } }: whoAreWeData): SagaIterator {
  try {
    const response = yield call(deleteWhoAreWeApi, id);
    const whoAreWeData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      whoAreWeDataApiResponseSuccess(
        WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA,
        whoAreWeData
      )
    );
    yield put(getWhoAreWeData());
  } catch (error: any) {
    yield put(
      whoAreWeDataApiResponseError(
        WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA,
        error
      )
    );
  }
}

export function* watchWhoAreWeData() {
  yield takeEvery(
    WhoAreWeActionTypes.CREATE_WHO_ARE_WE_DATA,
    createWhoAreWeData
  );
}
export function* watchUpdateWhoAreWeData() {
  yield takeEvery(
    WhoAreWeActionTypes.UPDATE_WHO_ARE_WE_DATA,
    updateWhoAreWeData
  );
}
export function* watchGetWhoAreWeData() {
  yield takeEvery(WhoAreWeActionTypes.GET_WHO_ARE_WE_DATA, getWhoAreWeDatas);
}

export function* watchDeleteWhoAreWeData() {
  yield takeEvery(
    WhoAreWeActionTypes.DELETE_WHO_ARE_WE_DATA,
    deleteWhoAreWeData
  );
}

function* whoAreWeSaga() {
  yield all([
    fork(watchWhoAreWeData),
    fork(watchUpdateWhoAreWeData),
    fork(watchDeleteWhoAreWeData),
    fork(watchGetWhoAreWeData),
  ]);
}

export default whoAreWeSaga;
